import { memo } from 'react';
import PropTypes from 'prop-types';

const BzTabsContent = ({ mountOnEnter,className, showDefault, isActive, children, tabKey, ...props }) => {

   if(mountOnEnter && !isActive) return null

    return (
        <div className={`tab-pane fade ${showDefault ? 'show' : ''} ${isActive ? 'active' : ''} ${className}`} id={tabKey} role="tabpanel" {...props} >
            {children}
        </div>
    )
}

BzTabsContent.propTypes = {
    className: PropTypes.string,
    isActive: PropTypes.bool,
    showDefault: PropTypes.bool,
    tabKey: PropTypes.string.isRequired,
    mountOnEnter:PropTypes.bool,
}

BzTabsContent.defaultProps = {
    className: "",
    isActive: false,
    showDefault: false,
    mountOnEnter:false
}

export default memo(BzTabsContent)
